import React from 'react';
import { SlideWrapper, GlassCard } from './SharedComponents';

export const OracleAppsSlide = ({ slide }) => (
  <SlideWrapper slide={slide} background={
    <div className="fixed inset-0 z-0">
      <div className="absolute inset-0 bg-[#0a0a10]" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1200px] h-[600px] bg-[#0068ff] opacity-[0.05] blur-[200px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-[#8b5cf6] opacity-[0.03] blur-[150px] rounded-full" />
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-[#22c55e] opacity-[0.03] blur-[120px] rounded-full" />
    </div>
  }>
    <div className="relative z-10 flex flex-col items-center justify-center h-full px-6 py-5">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-2 animate-slide-up">
        <span className="text-white">Integrated </span>
        <span className="text-[#0068ff]">Oracle Apps</span>
      </h2>
      <p className="text-white/35 text-sm text-center max-w-2xl mb-7 animate-fade-in" style={{ animationDelay: '0.05s' }}>{slide.subtitle}</p>

      <div className="grid grid-cols-3 gap-4 w-full max-w-[1050px]">
        {slide.apps.map((app, idx) => (
          <GlassCard key={idx} delay={0.1 + idx * 0.07} className="p-5 flex flex-col" style={{
            borderColor: 'rgba(255,255,255,0.06)'
          }}>
            <div className="flex items-center justify-between mb-4">
              <img src={app.logo} alt={app.name} className="w-12 h-12 rounded-xl object-contain" />
              <span className="text-[10px] font-bold px-2.5 py-1 rounded-full bg-[#22c55e] text-white">
                {app.status}
              </span>
            </div>

            <h3 className="text-white font-bold text-base mb-1.5">{app.name}</h3>
            <p className="text-white/35 text-xs leading-relaxed mb-4 flex-1">{app.description}</p>

            <div className="space-y-2">
              {app.features.map((feat, i) => (
                <div key={i} className="flex items-center gap-2">
                  <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 text-[#22c55e] shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 13l4 4L19 7" /></svg>
                  <span className="text-white/50 text-xs">{feat}</span>
                </div>
              ))}
            </div>

            {app.caseStudy && (
              <div className="mt-4 pt-3 border-t border-white/[0.06]">
                <span className="text-[#0068ff] text-xs font-medium flex items-center gap-1">
                  Read Case Study
                  <svg viewBox="0 0 24 24" className="w-3 h-3" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
                </span>
              </div>
            )}
          </GlassCard>
        ))}
      </div>
    </div>
  </SlideWrapper>
);
